import React, { useRef, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import * as d3 from 'd3';

const GaugeWithNeedle = ({chronologicalAge, realAge, min = 0, max = 100}) => {

  const svgRef = useRef();
  const containerRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 340, height: 340,  });

  const diff = realAge - chronologicalAge;
  const diffColor = diff < 0 ? 'green' : 'red';

// Resize observer for responsiveness
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width } = entry.contentRect;
        const height = width * 0.5; // 50% of width
        setDimensions({ width, height });
      }
    });

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);



  useEffect(() => {
    
    const { width, height } = dimensions;
    const svg = d3.select(svgRef.current);
    svg.selectAll('*').remove();

    const cx = width / 2;
    const cy = height;
    const radius = Math.min(width, height * 2) / 2 - 20;

    // Symmetric domain around chrono age
    const maxRange = Math.max(chronologicalAge - min, max - chronologicalAge);
    const domainMin = chronologicalAge - maxRange;
    const domainMax = chronologicalAge + maxRange;

    // Angle scale: center (chronologicalAge) is vertical (−π/2)
    const angleScale = d3.scaleLinear()
      .domain([domainMin, chronologicalAge, domainMax])
      .range([-Math.PI, -Math.PI / 2, 0])
      .clamp(true);

    const needleAngle = angleScale(realAge);
    const chronoAngle = -Math.PI / 2;

    // Arc background
    const arc = d3.arc()
      .innerRadius(radius - 25)
      .outerRadius(radius)
      .startAngle(-Math.PI)
      .endAngle(0);

    svg.append('path')
      .attr('transform', `translate(${cx},${cy})`)
      .attr('d', arc)
      .attr('fill', '#BFC2CF');

    // Chronological age center line
    const chronoX = cx + radius * Math.cos(chronoAngle);
    const chronoY = cy + radius * Math.sin(chronoAngle);
    //svg.append('line')
    //  .attr('x1', cx)
    //  .attr('y1', cy)
    //  .attr('x2', chronoX)
    //  .attr('y2', chronoY)
    //  .attr('stroke', '#1a1a1a')
    //  .attr('stroke-width', 4)
    //  .attr('stroke-dasharray', '6,4');

    // Needle

    // Improved needle: triangular shape
const needleLength = radius - 10;
const needleWidth = 8;

// Tip point (real age)
const tipX = cx + needleLength * Math.cos(needleAngle);
const tipY = cy + needleLength * Math.sin(needleAngle);

// Base points
const baseLeftX = cx + needleWidth * Math.cos(needleAngle - Math.PI / 2);
const baseLeftY = cy + needleWidth * Math.sin(needleAngle - Math.PI / 2);
const baseRightX = cx + needleWidth * Math.cos(needleAngle + Math.PI / 2);
const baseRightY = cy + needleWidth * Math.sin(needleAngle + Math.PI / 2);

// Draw needle triangle
svg.append('path')
  .attr('d', `M${baseLeftX},${baseLeftY} L${tipX},${tipY} L${baseRightX},${baseRightY} Z`)
  .attr('fill', diffColor)
  .attr('stroke', 'black')
  .attr('stroke-width', 0.5);

// Center cap
svg.append('circle')
  .attr('cx', cx)
  .attr('cy', cy)
  .attr('r', 5)
  .attr('fill', '#222')
  .attr('stroke', 'white')
  .attr('stroke-width', 1);

    // Arc ticks and labels
    const tickValues = d3.range(domainMin, domainMax + 1, 10);
    tickValues.forEach(value => {
      const angle = angleScale(value);
      const tickStartX = cx + (radius - 20) * Math.cos(angle);
      const tickStartY = cy + (radius - 20) * Math.sin(angle);
      const tickEndX = cx + (radius - 10) * Math.cos(angle);
      const tickEndY = cy + (radius - 10) * Math.sin(angle);

      // Tick line
      svg.append('line')
        .attr('x1', tickStartX)
        .attr('y1', tickStartY)
        .attr('x2', tickEndX)
        .attr('y2', tickEndY)
        .attr('stroke', '#222')
        .attr('stroke-width', 2);

      // Tick label
      const labelX = cx + (radius + 12) * Math.cos(angle);
      const labelY = cy + (radius + 12) * Math.sin(angle);
      
      svg.append('text')
        .attr('x', labelX)
        .attr('y', labelY + 8)
        .attr('text-anchor', 'middle')
        .attr('font-size', 16)
        .attr('fill', '#111111')
        .text(value);
    });


  }, [dimensions, realAge, chronologicalAge, min, max]);


  return (

    <Box ref={containerRef} sx={{width: '100%', pl:2,   }}>
    
    <svg
        ref={svgRef}
        width="80%"
        height={dimensions.height}
        viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
        preserveAspectRatio="xMidYMid meet"
      />

</Box>


  );
};

export default GaugeWithNeedle;





